import React from 'react';
import AddIcon from '../../svg/AddIcon';

const SetupAdd = (props) => {
    return (
        <div onClick={props?.onClick} style={{ fontWeight: 400, fontSize: 14, color: "#212121", display: 'flex', cursor: 'pointer' }}>
            <AddIcon />
            <div style={{ marginLeft: 6 }}>
                {props.children}
            </div>
        </div>
    );
}

export default SetupAdd;